/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/variant-button.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/variant-button.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
      (function () {
        if (window.__aoamStepsFromSelection) return;
        window.__aoamStepsFromSelection = 1;

        var norm = function (s) { return (s == null ? '' : String(s)).replace(/\s+/g, ' ').trim().toLowerCase(); };

        function formatter(cfg) {
          // 2026-10-10 audit (market-currency): the decimals group is optional, so a zero-decimal market (yen, won) keeps its own symbol and whole-unit amount instead of "$" and two-decimal math, and the thousands separator is read from the real 12,345.67 sample instead of a fixed "1x234" shape (so "12 345,67 kr" gives a space, "12.345,67" a dot). Joel 2026-10-10: "ship any fixes/finds" (sitewide audit). Roll back: restore the two match() patterns (/^(\D*)(\d)(\D)(\d\d)(\D*)$/ and /1(\D)234/) and whole = Math.floor(cents / 100), rem = cents % 100.
          var m = String(cfg.fmt || '').match(/^(\D*)(\d)(?:(\D)(\d\d))?(\D*)$/);
          var pre = m ? m[1] : '$', dec = m ? m[3] : '.', suf = m ? m[5] : '', zero = !!(m && !m[3]);
          var g = String(cfg.grp || '').match(/\d(\D)\d{3}(?!\d)/);
          var grp = g ? g[1] : ',';
          return function (cents) {
            var whole = zero ? Math.round(cents / 100) : Math.floor(cents / 100), rem = zero ? 0 : cents % 100;
            var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, grp);
            return pre + w + (rem ? dec + (rem < 10 ? '0' : '') + rem : '') + suf;
          };
        }

        // One snippet render per OPTION, so each wrapper holds a single fieldset. The first cut
        // ran per wrapper, which meant a group could never see the other option's selection: the
        // variant lookup got [Sol, null] and matched nothing, so every picker returned early and
        // the badges never changed. Resolve to the FORM instead, which holds every picker for one
        // product, and still keep one product's table with that product's form.
        function run(wrapRoot, cfg) {
          if (!cfg || !cfg.rows || !cfg.rows.length) return;
          var rows = cfg.rows, money = formatter(cfg);

          var wraps = [].slice.call(wrapRoot.querySelectorAll('.variant-input-wrap'));
          var groups = [];
          wraps.forEach(function (fs) {
            var chips = [].slice.call(fs.querySelectorAll('.variant-input')).map(function (c) {
              var inp = c.querySelector('input');
              return { el: c, val: inp ? inp.value : '', checked: inp ? !!inp.checked : false };
            }).filter(function (c) { return c.val; });
            if (!chips.length) return;
            var idx = -1;
            // 2026-10-12 (Claude, per-end pattern pickers, see the aoam_pair_n note above): Saber 1 and Saber 2 carry identical values, so matching values column by column put BOTH on column 0 and every Saber 2 price was wrong. Take the column from the fieldset's data-index (option1..3) when a chip value really sits in that column. Roll back: delete these two lines.
            var di = /option(\d)/.exec(fs.getAttribute('data-index') || ''), dn = di ? +di[1] - 1 : -1;
            if (dn >= 0 && dn < 3 && chips.some(function (c) { var v = norm(c.val); return rows.some(function (r) { return norm(r[dn]) === v; }); })) idx = dn;
            for (var i = 0; i < 3 && idx < 0; i++) {
              for (var j = 0; j < chips.length; j++) {
                var v = norm(chips[j].val);
                if (rows.some(function (r) { return norm(r[i]) === v; })) { idx = i; break; }
              }
            }
            if (idx < 0) return;
            // 2026-09-23 (Claude) - Joel, on the BitWhip Kit size picker: "these look like shit
            // on the bitwhip kit page. revert back to what it was". The option-D rewrite of
            // 2026-09-21 created a badge whenever one was missing, so it switched price steps ON
            // for every multi-variant product on the site, ignoring the aoam-price-steps tag gate
            // that the Liquid above uses. The BitWhip Kit has never carried that tag, so its
            // +$10 / +$20 pills arrived without anyone choosing them. Seed once, before anything
            // is mutated, from whether the server actually rendered a badge in this fieldset:
            // recompute existing badges (which is the whole point of option D) but never invent
            // one. Delete these three lines and the guard below to roll back.
            if (fs.getAttribute('data-aoam-steps-seed') == null) {
              fs.setAttribute('data-aoam-steps-seed', fs.querySelector('.aoam-price-step, .aoam-pill-step') ? '1' : '0');
            }
            groups.push({ fs: fs, chips: chips, idx: idx });
          });
          if (!groups.length) return;

          var sel = [null, null, null];
          groups.forEach(function (g) {
            var c = g.chips.filter(function (x) { return x.checked; })[0] || g.chips[0];
            sel[g.idx] = c.val;
          });

          function priceOf(idx, val) {
            var want = sel.slice();
            want[idx] = val;
            for (var i = 0; i < rows.length; i++) {
              var r = rows[i], ok = true;
              for (var k = 0; k < 3; k++) {
                if (want[k] == null && r[k] == null) continue;
                if (norm(want[k]) !== norm(r[k])) { ok = false; break; }
              }
              if (ok) return r[3];
            }
            return null;
          }

          var cur = priceOf(groups[0].idx, sel[groups[0].idx]);
          if (cur == null) return;

          groups.forEach(function (g) {
            // Image-swatch pickers style the badge on the span itself; plain pills need
            // has-aoam-step on the LABEL or the badge is not positioned, so the class is added and
            // removed in step with the badge rather than left behind.
            var isCard = !!g.fs.querySelector('img');
            var cls = isCard ? 'aoam-price-step' : 'aoam-pill-step';
            g.chips.forEach(function (c) {
              var label = c.el.querySelector('label') || c.el;
              var badge = c.el.querySelector('.aoam-price-step, .aoam-pill-step');
              var p = priceOf(g.idx, c.val);
              var d = p == null ? 0 : p - cur;
              // 2026-10-01 (Claude, Joel: "i dont like how variant boxes change height when you click them"): the picked chip keeps its badge, hidden, so its text wraps the same way and the row height holds.
              // 2026-10-01 (Claude, Joel picked D1): blade holder chips show their own price, always visible (picked too, so nothing resizes), and the bundle gets a grey "save $X" vs buying the holder separately.
              // 2026-10-01 (Claude, Joel: "push live universally"): absolute prices on EVERY price-step picker, not just blade holders. Kill switch: window.AOAM_ABS_PRICES = false restores the +/- steps.
              if (window.AOAM_ABS_PRICES !== false) {
                if (p == null) {
                  // 2026-10-10 audit (variant-no-resize, picker-prices): this pair is not a real variant, so hide the badge an earlier pick left on it. visibility, never removal, so the chip keeps its size. Roll back: put the single line `if (p == null) return;` back in place of this block.
                  if (badge) { badge.style.visibility = 'hidden'; badge.setAttribute('aria-hidden', 'true'); }
                  return;
                }
                if (!badge) {
                  if (g.fs.getAttribute('data-aoam-steps-seed') !== '1') return;
                  badge = document.createElement('span'); if (isCard) label.appendChild(badge); else label.insertBefore(badge, label.firstChild);
                }
                // 2026-10-01 H1: 3+ values = real price on the cheapest, +$X on the rest, measured against the current selection of the other options.
                var minP = null;
                if (g.chips.length > 2 && !cfg.table) g.chips.forEach(function (x) { var q = priceOf(g.idx, x.val); if (q != null && (minP == null || q < minP)) minP = q; });
                badge.className = cls; badge.textContent = (minP != null && p > minP) ? '+' + money(p - minP) : money(p);
                badge.style.visibility = ''; badge.removeAttribute('aria-hidden');
                if (!isCard) label.classList.add('has-aoam-step');
                // 2026-10-10 audit (variant-no-resize, tablet): on an inline pill the price column was as wide as whatever price showed, so a pick in ANOTHER option (LED Staff Saber Type: +$10 became +$30, +$30 became +$60) made a title that sits within a pixel of its line end wrap and the Length row grew 9.5px at 768. Each inline badge now holds the widest price its chip can ever show. A stacked badge (justify-self:center) has no title beside it, so it is left alone. Rajdhani has no tabular figures, so this measures instead. Joel 2026-10-10: "ship any fixes/finds" (sitewide audit). Roll back: delete this block and the document.fonts line near the end of this script.
                if (!isCard) {
                  var cs = getComputedStyle(badge);
                  if (cs.justifySelf === 'center') { badge.style.minWidth = ''; badge.style.textAlign = ''; }
                  else {
                    var cx = window.__aoamCx || (window.__aoamCx = document.createElement('canvas').getContext('2d')), fpx = parseFloat(cs.fontSize);
                    if (cx && fpx > 0) {
                      cx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
                      // Only measure once the real face is loaded (fallback widths would be wrong); document.fonts.ready re-runs this.
                      if (!document.fonts || !document.fonts.check || document.fonts.check(cx.font)) {
                        var ls = parseFloat(cs.letterSpacing) || 0, wMax = 0;
                        rows.forEach(function (r) {
                          if (norm(r[g.idx]) !== norm(c.val)) return;
                          var mn = null;
                          rows.forEach(function (s) {
                            for (var k = 0; k < 3; k++) { if (k !== g.idx && norm(s[k]) !== norm(r[k])) return; }
                            if (mn == null || s[3] < mn) mn = s[3];
                          });
                          var t = (g.chips.length > 2 && !cfg.table && r[3] > mn) ? '+' + money(r[3] - mn) : money(r[3]);
                          wMax = Math.max(wMax, cx.measureText(t).width + ls * t.length);
                        });
                        if (wMax > 0) { badge.style.minWidth = (Math.ceil(wMax / fpx * 10000) / 10000) + 'em'; badge.style.textAlign = 'right'; }
                      }
                    }
                  }
                }
                var other = g.chips.length === 2 ? g.chips.filter(function (x) { return x !== c; })[0] : null;
                var base = other ? priceOf(g.idx, other.val) : null;
                var save = (/holder/i.test(c.val) && cfg.holder > 0 && base != null) ? base + cfg.holder - p : 0;
                var sv = label.querySelector('.aoam-pill-save');
                if (save > 0) {
                  if (!sv) { sv = document.createElement('em'); sv.className = 'aoam-pill-save'; label.appendChild(sv); }
                  sv.textContent = 'save ' + money(save);
                } else if (sv && sv.parentNode) { sv.parentNode.removeChild(sv); }
                return;
              }
              if (c.checked && badge) { badge.style.visibility = 'hidden'; badge.setAttribute('aria-hidden', 'true'); return; }
              if (c.checked || d === 0) {
                if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
                label.classList.remove('has-aoam-step');
                return;
              }
              if (!badge) {
                // 2026-09-23: only ever re-draw a badge this product was rendered with. See the
                // data-aoam-steps-seed note above.
                if (g.fs.getAttribute('data-aoam-steps-seed') !== '1') return;
                badge = document.createElement('span'); label.appendChild(badge);
              }
              badge.className = cls;
              badge.textContent = (d > 0 ? '+' : '-') + money(Math.abs(d));
              badge.style.visibility = ''; badge.removeAttribute('aria-hidden');
              if (!isCard) label.classList.add('has-aoam-step');
            });
          });
        }

        function runAll() {
          var seen = [];
          [].slice.call(document.querySelectorAll('script.aoam-steps-data')).forEach(function (s) {
            var root = (s.closest && (s.closest('form.product-single__form') || s.closest('form'))) ||
                       (s.closest && s.closest('.product-summery__info')) || document.body;
            if (seen.indexOf(root) > -1) return;
            seen.push(root);
            var cfg = null;
            try { cfg = JSON.parse(s.textContent); } catch (e) { return; }
            try { run(root, cfg); } catch (e) { /* never let a picker break the page */ }
          });
        }

        var t = null;
        function schedule() { clearTimeout(t); t = setTimeout(runAll, 60); }

        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
        else schedule();
        // 2026-10-10 audit (variant-no-resize): the price-column reserve is measured in Rajdhani, so recompute once the web font has loaded. Roll back: delete this line.
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
        // The theme flips the checked radio and repaints the price asynchronously, so recompute a
        // beat after any change rather than inside the same tick.
        document.addEventListener('change', function (e) {
          if (e.target && e.target.closest && e.target.closest('.variant-input-wrap')) schedule();
        }, true);
        document.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('.variant-input')) schedule();
        }, true);
      })();
    